import { useQuery } from '@tanstack/react-query';
import { staffApi } from '../api/staffApi';
import { useMemo } from 'react';
import { useMe } from 'core/me/provider/MeProvider';

export const staffKeys = {
  all: (companyId) => ['staff', 'all', String(companyId)],
};

export function useStaffSplitLists() {
  const { me } = useMe(); // ✅ burada shape farklıysa uyarlarsın
  const companyId = me?.companyId; // ✅

  const q = useQuery({
    queryKey: staffKeys.all(companyId),
    queryFn: () => staffApi.list(),
    enabled: !!companyId,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const { workingList, passiveList } = useMemo(() => {
    const arr = Array.isArray(q.data) ? q.data : [];
    return {
      workingList: arr.filter((x) => x?.working === true),
      passiveList: arr.filter((x) => x?.working === false),
    };
  }, [q.data]);

  return { ...q, workingList, passiveList };
}
